export default __webpack_public_path__ + "static/november-pro-regular-b8a45196ee92b574e7ea92586fdb9768.woff2";